<template>
    <div>
        <Exception type="404" img-color :desc="$t('page.exception.e404')" :back-text="$t('page.exception.btn')" />
    </div>
</template>
<script>
    export default {
        name:'plat-error404',
    }
</script>



// WEBPACK FOOTER //
// src/pages/error/404/index.vue